import { useEffect, useState, useRef } from "react"
import React from "react";
import InsureBodyCar from "./BodyCarInformation/index"
import InsureOffline from "./OfllineInformation/index"
import InsureThirdParty from "./ThirdPartyInformation/index"
import InsureTravel from "./TravelInformation/index"
import InsureFireHome from "./FireHomeInformation/index"
import InsureDoctor from "./ResponseDoctorInformation/index"
import InsureBuilding from "./BuildingQualityInformation/index"
import InsureCorona from "./CoronaInformation/index"
import InsureTherapy from "./treatment/index"
import InsureElevator from "./ElevatorInformation/InsureElevator"
import InsureBuildingManagement from "./buildingManagerInformation/index"
import { Cookies } from "react-cookie"
import Plans from "./PlansInformation/Plans"

// import { $postWithResult } from "../../plugins/axios"
import * as constants from "../../constants";

export default function InsureInformation({ ReqId }) {
   const [data, setData] = useState({ data: [{ jsonpricing_fieldinsurance: "" }] })
   const cookies = new Cookies()

   async function getRequestInsure() {
      if (cookies.get("employee_token_str")) {
         var xhttp = new XMLHttpRequest()
         xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
               var arr = JSON.parse(this.responseText)
               console.log(arr)
               if (arr.result === "ok") {
                  if (arr.data.length !==0) {

                     setData(arr)
                  }
               }
            }
         }
         var fd = new FormData()
         fd.append("command", "get_request")
         fd.append("request_id", ReqId)

         xhttp.open("POST", `${constants.BASE_URL}/getrequestemployee`)
         xhttp.setRequestHeader("Authorization", cookies.get("employee_token_str"))
         xhttp.send(fd)
      } else {
         this.setState({ redirect: true })
      }
   }
   useEffect(() => {
      getRequestInsure()
   }, [])

   if (data.data.length > 0) {

      if (data.data[0].request_packageinsurance_id !== "0") {
         return <Plans data={data} />
      } else {
         if (data.data[0].request_fieldinsurance === "bodycarins") {
            return <InsureBodyCar data={data} />
         }
         if (
            data.data[0].request_fieldinsurance .includes( "thirdpartyins")
         ) {
            return <InsureThirdParty data={data} />
         }
         if (data.data[0].request_fieldinsurance === "travelins") {
            return <InsureTravel data={data} />
         }
         if (data.data[0].request_fieldinsurance === "firehomeins") {
            return <InsureFireHome data={data} />
         }
         if (data.data[0].request_fieldinsurance === "responsdoctorsins") {
            return <InsureDoctor data={data} />
         }
         if (data.data[0].request_fieldinsurance === "buildingqualityins") {
            return <InsureBuilding data={data} />
         }
         if (data.data[0].request_fieldinsurance === "coronains") {
            return <InsureCorona data={data} />
         }
         if (data.data[0].request_fieldinsurance === "therapyins") {
            return <InsureTherapy data={data} />
         }
         if (data.data[0].request_fieldinsurance === "elevatorins") {
            return <InsureElevator data={data} />
         }
         if (data.data[0].request_fieldinsurance === "res_build_manage_ins") {
            console.log("---------------------------");
            return <InsureBuildingManagement data={data} />
         }
         const detailJson = data.data[0].request_detail_json;
         const parsed = JSON.parse(detailJson);

         return <InsureOffline data={parsed.data} />;


         return <></>
      }
   }
}
